import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import { termApi } from './term.queries';

export default function TermAutocomplete(props) {
	const useGetAll = termApi.useGetAll();
	const terms = useGetAll.data;

	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState([]);

	useEffect(() => {
		if (terms?.length && props?.defaultValue) {
			setSelected(terms.filter((s) => props.defaultValue.includes(s.id)));
		}
	}, [terms, props?.defaultValue]);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleChange = (e, newValue) => {
		setSelected(newValue);
		props?.onChange?.(newValue);
	};

	return (
		<Autocomplete
			multiple
			open={open}
			onOpen={handleOpen}
			onClose={handleClose}
			onChange={handleChange}
			getOptionLabel={(option) => option.name}
			getOptionKey={(option) => option.id}
			value={selected}
			options={terms}
			loading={useGetAll.isPending}
			renderInput={(params) => (
				<TextField {...params} label="Filter Terms..." slotProps={{
					input: {
						...params.InputProps,
						endAdornment: (
							<React.Fragment>
								{useGetAll.isPending ? <CircularProgress color="inherit" size={20} /> : null}
								{params.InputProps.endAdornment}
							</React.Fragment>
						),
					},
				}}/>
			)}
		/>
	);
}